<app-tags-data-table [columns]="columns.value" (modifyColumns)="modifyColumns.emit()" [searchLoader]="loader" [showHeaders]="desktopView"></app-tags-data-table>
<ng-container *ngIf="!desktopView">
    <div class="separator16"></div>
    <app-plus-button *ngIf="canAdd" (plusClicked)="addTag()"></app-plus-button>
</ng-container>
